/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertId } from './InternalApiAlertId';
import {
    InternalApiAlertIdFromJSON,
    InternalApiAlertIdFromJSONTyped,
    InternalApiAlertIdToJSON,
    InternalApiAlertIdToJSONTyped,
} from './InternalApiAlertId';

/**
 * Alert assignment
 * @export
 * @interface InternalApiAlertBulkAssignment
 */
export interface InternalApiAlertBulkAssignment {
    /**
     * 
     * @type {Array<InternalApiAlertId>}
     * @memberof InternalApiAlertBulkAssignment
     */
    alerts?: Array<InternalApiAlertId>;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertBulkAssignment
     */
    assigneeId?: number;
}

/**
 * Check if a given object implements the InternalApiAlertBulkAssignment interface.
 */
export function instanceOfInternalApiAlertBulkAssignment(value: object): value is InternalApiAlertBulkAssignment {
    return true;
}

export function InternalApiAlertBulkAssignmentFromJSON(json: any): InternalApiAlertBulkAssignment {
    return InternalApiAlertBulkAssignmentFromJSONTyped(json, false);
}

export function InternalApiAlertBulkAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertBulkAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': json['alerts'] == null ? undefined : ((json['alerts'] as Array<any>).map(InternalApiAlertIdFromJSON)),
        'assigneeId': json['assigneeId'] == null ? undefined : json['assigneeId'],
    };
}

export function InternalApiAlertBulkAssignmentToJSON(json: any): InternalApiAlertBulkAssignment {
    return InternalApiAlertBulkAssignmentToJSONTyped(json, false);
}

export function InternalApiAlertBulkAssignmentToJSONTyped(value?: InternalApiAlertBulkAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': value['alerts'] == null ? undefined : ((value['alerts'] as Array<any>).map(InternalApiAlertIdToJSON)),
        'assigneeId': value['assigneeId'],
    };
}

